import { render, staticRenderFns } from "./Account2FAView.vue?vue&type=template&id=835a64ca"
import script from "./Account2FAView.vue?vue&type=script&lang=js"
export * from "./Account2FAView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports